import Check from './operation-panel-button/check.jsx'
import Submit from './operation-panel-button/submit.jsx'
import CountDown from './operation-panel-button/count-down.jsx'
import { getCountDownTime, getCanBeShare } from '../../lib/xes/xes.js'
import CheckLayer from '../check-layer/check-layer.jsx'
import SmartLayer from '../smartFB/smart-layer.jsx'

import ClassworkModal from '../classwork-modal/classwork-modal'
import React, { useState } from 'react'
import { getXesEnvHanlder } from '../../lib/xes/xes'
import './panel.css'
// 引入检查弹窗

export let goldModal;


export default () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [goldUrl, setGoldUrl] = useState('')
  goldModal = {
    toggle(isOpen, url) {
      if (url) {
        setGoldUrl(url)
      }
      setIsModalOpen(isOpen)
    }
  }
  const handler = getXesEnvHanlder()
  handler.setModal(goldModal)
  return (
    <div className="panel">
      <ClassworkModal
        isOpen={isModalOpen}
        close={() => setIsModalOpen(false)}
        goldUrl={goldUrl}
        canBeShare={getCanBeShare()}
      />
      <CountDown countDownTime={getCountDownTime()} />
      <Check />
      <Submit />
      <CheckLayer />
      <SmartLayer />
    </div>
  )
}
